import { useEffect } from "react";
import { useLocation } from "react-router";

// react-router here runs in declarative mode (<BrowserRouter>/<Routes>), not
// the data-router API, so <ScrollRestoration> isn't available — it only
// works with createBrowserRouter. Several pages also toggle
// document.documentElement.style.scrollBehavior = "smooth" for in-page
// anchor links, so pathname-only navigation forces an instant jump rather
// than inheriting smooth scroll on every route change.
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, "");
      // Wait a frame so the destination page has painted section anchors.
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
